import { createContext, useContext } from 'react';

/**
 * Lets a page declare its title to the admin chrome. `PageHeader` registers the
 * active page's title here; `AdminTopNav` renders it (next to the ⓘ hint) in the
 * top bar's centre slot. The provider value is supplied by `AdminShell`.
 *
 * A `null` context means we're rendered OUTSIDE the shell (e.g. a page mounted
 * directly in a unit test). In that case `PageHeader` falls back to rendering
 * the title in the page body, so standalone renders + existing tests are
 * unaffected.
 */
export interface PageTitleContextValue {
  readonly title: string | null;
  readonly setTitle: (title: string | null) => void;
}

export const PageTitleContext = createContext<PageTitleContextValue | null>(null);

/** Returns the page-title context, or `null` when rendered outside `AdminShell`. */
export function usePageTitleContext(): PageTitleContextValue | null {
  return useContext(PageTitleContext);
}
